export default __webpack_public_path__ + "static/help_06_03-7-08199584ba5b7d8177bcd2a0d0210e50.png";